module.exports = __webpack_public_path__ + "static/img/qualifications_row_2.a6b4d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_2.png
// module id = y/IN
// module chunks = 1